export default "__VITE_ASSET__ChkkrdWk__"